import { ReactNode, useCallback, useState } from 'react';
import { FloorExceptionalClosingHoursResponse } from '@jooxter/api';
import { FloorExceptionalClosingHoursFormContext } from './useFloorExceptionalClosingHoursFormContext';

export const FloorExceptionalClosingHoursFormProvider = ({ children }: { children: ReactNode }) => {
  const [showFloorExceptionalClosingHours, setShowFloorExceptionalClosingHours] =
    useState<FloorExceptionalClosingHoursResponse | null>(null);

  const showFloorExceptionalClosingHoursDetails = useCallback(
    (floorExceptionalClosingHours: FloorExceptionalClosingHoursResponse) => {
      setShowFloorExceptionalClosingHours(floorExceptionalClosingHours);
    },
    []
  );

  const closeFloorExceptionalClosingHoursDetails = useCallback(() => {
    setShowFloorExceptionalClosingHours(null);
  }, []);

  return (
    <FloorExceptionalClosingHoursFormContext.Provider
      value={{
        showFloorExceptionalClosingHours,
        showFloorExceptionalClosingHoursDetails,
        closeFloorExceptionalClosingHoursDetails,
      }}
    >
      {children}
    </FloorExceptionalClosingHoursFormContext.Provider>
  );
};
